import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError, UnderReviewError } from 'src/shared/error';

import { getViewerSignature } from 'src/app/shared/api/signature';

import type {
	StarterDashboardV2PetitionDataQuery,
	StarterDashboardV2PetitionDataQueryVariables,
} from './petitionData.graphql';
import { StarterDashboardV2PetitionData } from './petitionData.graphql';

export type Petition = NonNullable<StarterDashboardV2PetitionDataQuery['petition']>;
export type StarterDashboardCommentsPetitionData = {
	petition: Petition;
	hasSignedPetition: boolean;
};

export async function getStarterDashboardCommentsPetitionData(
	utilityContext: UtilityContext,
	petitionSlug: string,
	userId: string | undefined,
): Promise<StarterDashboardCommentsPetitionData> {
	const { gql } = utilityContext;

	const [{ data }, signature] = await Promise.all([
		gql.fetch<StarterDashboardV2PetitionDataQuery, StarterDashboardV2PetitionDataQueryVariables>({
			query: StarterDashboardV2PetitionData,
			variables: {
				petitionSlugOrId: petitionSlug,
			},
			rejectOnError: true,
		}),
		userId ? getViewerSignature(petitionSlug, utilityContext) : Promise.resolve(undefined),
	]);

	if (!data.petition) {
		throw new NotFoundError();
	}

	if (data.petition.status === 'UNDER_REVIEW' && !data.petition.viewerCanEdit) {
		throw new UnderReviewError();
	}

	return {
		petition: data.petition,
		hasSignedPetition: !!signature,
	};
}
